import { assign } from "xstate";
import { track } from "../../actions";
export const informationScreenState = {
    entry: [track],
    on: {
        BACK: "price",
        NEXT: "summary",
        SET_FACILITY_INFORMATION: {
            actions: assign({
                facilityInformation: (_ctx, event) => event.facilityInformation,
            }),
        },
        SET_PERSON: {
            actions: assign({
                person: (_ctx, event) => event.person,
            }),
        },
        SET_INVOICE: {
            actions: assign({
                invoice: (_ctx, event) => event.invoice,
            }),
        },
        SET_START_DATE: {
            actions: assign({
                startDate: (_ctx, event) => event.startDate,
            }),
        },
        SET_FACILITY: {
            actions: assign({
                facility: (_ctx, event) => event.facility,
            }),
        },
        SET_HAS_FETCHED_PERSON_AUTOMATIC: {
            actions: assign({
                hasFetchedPersonAutomatic: (_ctx, event) => event.hasFetchedPersonAutomatic,
            }),
        },
    },
};
